import { MessageCallReceived, MessageIncomingEvent } from '@wui/im'

export enum EmitterEvents {
  NEW_MESSAGE = 'newMessage',
  UPDATE_STATUS = 'updateStatus',
  REMOTE_BUSY = 'remoteBusy',
  TOGGLE_MUTE_VIDEO_IN_CONFERENCE = 'toggleMuteVideoInConference',
  TOGGLE_SCREEN_SHARING_IN_CONFERENCE = 'toggleScreenSharingInConference',
  RECORD_ITEM_CONTROL = 'recordItemControl',
  REMOVE_MEMBER = 'removeMember',
  DELETE_ROOM = 'deleteRoom',
  CHANGE_ACTIVE_PARTICIPANTS_COUNT_IN_ACTIVE_ROOM = 'changeActiveParticipantsCountInActiveRoom'
}

export interface NewMessageEmitterEvent {
  roomId?: string,
  event: MessageIncomingEvent | MessageCallReceived
}

export interface ChangeActiveParticipantsCountInActiveRoomEvent {
  roomPServed: string,
  count: number
}
